import React, { useContext } from 'react';
import styled from 'styled-components';
import { whiteOpacity10, white, gray500 } from 'constants/colors';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserAuthContext } from 'context/UserAuthContext';

const Menu: React.FC = () => {
  const { t } = useTranslation('navigation');
  const userAuthContext = useContext(UserAuthContext);
  const hasSdRecordViewerService: boolean =
    userAuthContext?.has_auth_for_sd_record_viewer_service !== undefined
      ? userAuthContext?.has_auth_for_sd_record_viewer_service
      : false;

  return (
    <NavigationItemList>
      <NavigationItem>
        <StyledLink
          $isclickable={hasSdRecordViewerService}
          to={'/sd_record_viewer/camera_list'}
        >
          {t('sdRecordViewer')}
          {!hasSdRecordViewerService && '[未契約]'}
        </StyledLink>
      </NavigationItem>
    </NavigationItemList>
  );
};

const NavigationItemList = styled.ul`
  position: relative;
  width: 100%;
  margin: 40px 0 0;
  padding: 0;
  list-style: none;
`;

const NavigationItem = styled.li`
  position: relative;
  z-index: 20;
  width: 260px;
  padding: 20px;
  color: ${white};
  transition: background-color 0.1s ease;

  &:hover {
    background-color: ${whiteOpacity10};
  }
`;

type PropsType = {
  $isclickable: boolean;
};

const StyledLink = styled(Link)<PropsType>`
  display: block;
  margin: -20px;
  padding: 20px;
  color: inherit;
  ${({ $isclickable }) =>
    !$isclickable && `pointer-events: none; color: ${gray500};`}

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

export default Menu;
